let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2EUA8")).then(() => parcelRequire('dV1HL'));